<template>
    <div class="pop__side_email">
        <template v-if="!emailId">
            <component-loading/>
        </template>
        <template v-else>
            <div class="pop__side_box_main_inner pop__side_email_box_main_inner">
                <div class="pop__side_email_box_main_inner_email">
                    <div class="pop__side_email_box_main_inner_email_title">
                        <form-text
                            :disabled="disabled"
                            :label="'Title'"
                            :required="true"
                            :v-validate="'required'"
                            :name="'email-title'"
                            v-model="emailTitle"
                        />
                    </div>
                    <div class="pop__side_email_box_main_inner_email_subject">
                        <form-text
                            :disabled="disabled"
                            :label="$t('shared.pop.labels.subject')"
                            :required="true"
                            :v-validate="'required'"
                            :name="'email-subject'"
                            v-model="emailSubject"
                        />
                    </div>
                    <div class="pop__side_email_box_main_inner_email_editor">
                        <form-editor
                            ref="formeditor"
                            :name="'pop-side-email-editor'"
                            :disabled="disabled"
                            :tags="emailTags"
                            :is-email="true"
                            :has-option-url="true"
                            v-model="emailContent"
                        />
                    </div>
                    <template v-if="emailTriggerEvent === 'SendCourseRemindersToLearnersEvent'">
                        <div class="pop__side_email_box_main_inner_email_settings">
                            <component-title :size="'medium'">Settings</component-title>
                            <component-wrapper :class="'pop__side_email_box_main_inner_email_settings_remindersend'">
                                <component-title :size="'label'">Send</component-title>
                                <div class="columns is-vcentered">
                                    <div class="column is-narrow">
                                        <form-number
                                            :label="''"
                                            :name="'pop-side-email-send-period'"
                                            v-model="emailReminderSendAfterDays"
                                        ></form-number>
                                    </div>
                                    <div class="column is-narrow">
                                        <form-select
                                            :label="''"
                                            :name="'pop-side-email-send-number-periodtype'"
                                            :items="[
                                                {
                                                    label: 'Days',
                                                    value: 'days'
                                                }
                                            ]"
                                            :value="'days'"
                                            :disabled="true"
                                            :prevent-clear="true"
                                        ></form-select>
                                    </div>
                                    <div class="column">
                                        after enrolment
                                    </div>
                                </div>
                            </component-wrapper>
                            <component-wrapper :class="'pop__side_email_box_main_inner_email_settings_reminderresend'">
                                <component-title :size="'label'">Resend the reminder</component-title>
                                <form-radio
                                    :name="'pop-side-email-reminder-never'"
                                    :label="''"
                                    :items="[
                                    {
                                        name: 'Never',
                                        value: 'never'
                                    }
                                ]"
                                    :value="emailResendReminderPeriod === 0 ? 'never' : ''"
                                    @input="() => emailResendReminderPeriod = 0"
                                ></form-radio>
                                <div class="columns is-vcentered">
                                    <div class="column is-narrow">
                                        <form-radio
                                            :name="'pop-side-email-reminder-never'"
                                            :label="''"
                                            :items="[
                                            {
                                                name: 'Every',
                                                value: 'every'
                                            }
                                        ]"
                                            :value="emailResendReminderPeriod !== 0 ? 'every' : ''"
                                            @input="() => emailResendReminderPeriod = 1"
                                        ></form-radio>
                                    </div>
                                    <div class="column is-narrow">
                                        <div class="columns is-vcentered">
                                            <div class="column is-narrow">
                                                <form-number
                                                    :label="''"
                                                    :name="'pop-side-email-resend-period'"
                                                    :disabled="emailResendReminderPeriod === 0"
                                                    v-model="emailResendReminderPeriod"
                                                ></form-number>
                                            </div>
                                            <div class="column is-narrow">
                                                <form-select
                                                    :label="''"
                                                    :name="'pop-side-email-resend-periodtype'"
                                                    :disabled="true"
                                                    :items="[
                                                        {
                                                            label: 'Days',
                                                            value: 'days'
                                                        }
                                                    ]"
                                                    :value="'days'"
                                                    :prevent-clear="true"
                                                ></form-select>
                                            </div>
                                            <div class="column is-narrow">
                                                for
                                            </div>
                                            <div class="column is-narrow">
                                                <form-number
                                                    :label="''"
                                                    :name="'pop-side-email-resend-count'"
                                                    :disabled="emailResendReminderPeriod === 0"
                                                    v-model="emailResendReminderCount"
                                                ></form-number>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column">
                                        occurrences
                                    </div>
                                </div>
                            </component-wrapper>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import FormSelect from '@/components/default/forms/FormSelect'
import FormText from '@/components/default/forms/FormText'
import FormEditor from '@/components/default/forms/FormEditor'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import FormRadio from '@/components/default/forms/FormRadio'
import FormNumber from '@/components/default/forms/FormNumber'

export default {
  components: {
    FormNumber,
    FormRadio,
    ComponentWrapper,
    ComponentTitle,
    ComponentLoading,
    FormEditor,
    FormText,
    FormSelect
  },
  name: 'pop-side-email',
  data () {
    return {
      isCcbccActive: false,
      preventWatchComputed: true
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    emailId: {
      get () {
        return this.$store.getters.getEmailId
      },
      set (value) {
        this.$store.dispatch('setEmailId', value)
      }
    },
    emailName: {
      get () {
        return this.$store.getters.getEmailName
      },
      set (value) {
        this.$store.dispatch('setEmailName', value)
      }
    },
    emailTitle: {
      get () {
        return this.$store.getters.getEmailTitle || this.$store.getters.getEmailName
      },
      set (value) {
        this.$store.dispatch('setEmailTitle', value)
      }
    },
    emailSubject: {
      get () {
        return this.$store.getters.getEmailSubject
      },
      set (value) {
        this.$store.dispatch('setEmailSubject', value)
      }
    },
    emailContent: {
      get () {
        return this.$store.getters.getEmailContent
      },
      set (value) {
        this.$store.dispatch('setEmailContent', value)
      }
    },
    emailTags: {
      get () {
        return this.$store.getters.getEmailTags
      }
    },
    emailTriggerEvent: {
      get () {
        return this.$store.getters.getEmailTriggerEvent
      }
    },
    emailReminderSendAfterDays: {
      get () {
        return this.$store.getters.getEmailReminderSendAfterDays
      },
      set (value) {
        this.$store.dispatch('setEmailReminderSendAfterDays', value)
      }
    },
    emailResendReminderCount: {
      get () {
        return this.$store.getters.getEmailResendReminderCount
      },
      set (value) {
        this.$store.dispatch('setEmailResendReminderCount', value)
      }
    },
    emailResendReminderPeriod: {
      get () {
        return this.$store.getters.getEmailResendReminderPeriod
      },
      set (value) {
        this.$store.dispatch('setEmailResendReminderPeriod', value)
        if (this.emailResendReminderCount === '') {
          this.emailResendReminderCount = 0
        }
      }
    },
    computedWatch () {
      return this.emailId + this.emailName + this.emailTitle + this.emailSubject + this.emailContent + this.emailReminderSendAfterDays + this.emailResendReminderCount + this.emailResendReminderPeriod
    }
  },
  watch: {
    computedWatch () {
      if (this.$parent.handleSlotContentChanged && !this.preventWatchComputed) {
        this.$parent.handleSlotContentChanged()
      }
    }
  },
  methods: {
    switchCcbcc: function () {
      this.isCcbccActive = !this.isCcbccActive
    },
    //
    reset () {
      const defaultContent = this.$store.getters.getEmailDefaultContent
      this.$refs.formeditor.reset(defaultContent)
    },
    submit () {
      this.$emit('emit-submit', this.emailId)
    }
  },
  mounted () {
    setTimeout(() => {
      this.preventWatchComputed = false
    }, 1000)
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/popsideemail";
</style>
